import styled from "styled-components";

export const FooterContainer = styled.div`
  height: 45px;
  background-color: #282733;
  z-index: 999;
  color: #fff;
  padding: 0 15px;
  width: 100%;
  display: flex;
  .footer-section {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    button {
      font-weight: 500;
      font-size: 16px;
      padding: .45rem .8rem;
      font-size: .875rem;
      line-height: 1.5;
    }
  }
`;
